import styled from 'styled-components'
import { LIGHTGRAY } from '../../../styles/colors.style'
import { breakpoints } from './../../../constants/breakpoits.constants'
import { borderRadius } from '../../../styles/reusable.style'

export const StyledStartingAt = styled.p`
	font-size: 3.2rem;
`

export const StyledContainer = styled.div`
	align-self: flex-start;
`

export const StyledConditionsContainer = styled.div`
	display: flex;
	flex-direction: column;
`

export const StyledPaymentCondition = styled.div`
	align-items: center;
	border: 1px solid ${LIGHTGRAY};
	border-radius: ${borderRadius};
	display: flex;
	flex-direction: column;
	padding: 7px 7px 0px 7px;

	&:first-child {
		margin-bottom: 10px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		height: 80px;
		align-items: center;
	}
`

export const StyledIconContainer = styled.div`
	margin-right: 9px;
	width: 128px;
`
